import { WhatsNewState } from '../types/whatsNew.types';

export const selectWhatsNew = (state: { whatsNew: WhatsNewState }) =>
	state.whatsNew;
